module.exports = __webpack_public_path__ + "static/media/01B.979366e1.png";